import React from "react";

const BuilderContext = React.createContext({});
export const BuilderProvider = BuilderContext.Provider

export default BuilderContext